import React from 'react';
import { spacing } from '../../style';

import { Div, Flex } from '../../components/box';

import Text, { Label, TextProps } from '../../components/text';
import Icon from '../../components/icon';

export type TFieldTitleSize = TextProps['size'];

export interface FieldTitleProps {
  title?: string | React.ReactNode;
  fontFamily?: TextProps['fontFamily'];
  subtitle?: string | React.ReactNode;
  isInvalid?: boolean;
  isRequired?: boolean;
  htmlFor: string;
  marginBottom?: keyof typeof spacing;
  size?: TFieldTitleSize;
  children?: React.ReactNode;
}

const REQUIRED_ICON_CONTAINER_HEIGHT = 25;

const FieldTitle = ({
  title,
  fontFamily,
  subtitle,
  isInvalid,
  isRequired,
  htmlFor,
  marginBottom,
  size,
  children,
}: FieldTitleProps) => {
  return (
    <div>
      {(title || children) && (
        <Div
          data-name={'required-marker'}
          data-invalid={isInvalid}
          marginBottom={marginBottom || (subtitle ? 'xxs' : 'sm')}
        >
          <Flex gap={'xxs'} alignItems={'center'}>
            {children || (
              <Label
                fontFamily={fontFamily}
                weight={500}
                size={size}
                htmlFor={htmlFor}
                style={{ marginRight: spacing.xxs }}
              >
                {title}
              </Label>
            )}
            {isRequired && (
              <Div position={'relative'} height={REQUIRED_ICON_CONTAINER_HEIGHT}>
                {isInvalid ? (
                  <Text variant={'negative'} size={'xl'} weight={700}>
                    <i role={'img'} aria-label={'Required'}>
                      <span aria-hidden={'true'}>*</span>
                    </i>
                  </Text>
                ) : (
                  <Icon
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '2px',
                      transform: 'translate(-50%, -50%)',
                    }}
                    variant={'action'}
                    name={'DONE'}
                    aria-label={'valid'}
                  />
                )}
              </Div>
            )}
          </Flex>
        </Div>
      )}

      {subtitle && (
        <Text
          fontFamily={fontFamily}
          marginBottom={marginBottom || 'sm'}
          variant={'gray600'}
          size={size === 'md' ? 'sm' : 'md'}
        >
          {subtitle}
        </Text>
      )}
    </div>
  );
};

export default FieldTitle;
